import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cloudinary from 'cloudinary-core';
import CloudinaryUtil from '../core/CloudinaryUtil';

const RESIZE_EVENT = 'resize';
const AUTO = 'auto';

export default class CloudinaryImage extends Component {

  static propTypes = {
    publicId: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    transformation: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(React.PropTypes.object)
    ]),
    handleLoad: PropTypes.func,
    breakpoints: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(React.PropTypes.number)
    ]),
    cname: PropTypes.string,
    privateCdn: PropTypes.bool,
    secureDistribution: PropTypes.string
  };

  static containerStyle = {
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0
  }

  constructor(props, context) {
    super(props, context);
    this.cl = props.cl;
    if (!this.cl) {
      this.cl = cloudinary.Cloudinary.new();
      this.cl.fromDocument();
    }
    this.breakpoints = CloudinaryUtil.breakpointFunction(this.props.breakpoints);
    this.state = { isResponsive: this.hasWidthAuto(this.props.transformation) };
  }

  componentWillReceiveProps(nextProps) {
    let newState = this.state;
    if (this.hasWidthAuto(this.props.transformation) !== this.hasWidthAuto(nextProps.transformation)) {
      if (this.hasWidthAuto(nextProps.transformation)) {
        this.getWindow().addEventListener(RESIZE_EVENT, this.handleResize);
        newState = {...newState, isResponsive: true };
      } else {
        this.getWindow().removeEventListener(RESIZE_EVENT, this.handleResize);
        newState = {...newState, isResponsive: false };
      }
    }
    if (this.props.publicId !== nextProps.publicId || !compareObjects(this.props.transformation, this.props.transformation)) {
      newState = {...newState, error: false, maxContainerWidth: newState.containerWidth };
    }
    if (newState != this.state) {
      this.setState(newState);
    }
  }

  hasWidthAuto(transformation) {
    if (Array.isArray(transformation)) {
      let exists = false;
      for (let t of transformation) {
        if (this.hasWidthAuto(t)) {
          exists = true;
          break;
        }
      }
      return exists;
    } else {
      return transformation.width === AUTO;
    }
  }

  getWidth(container) {
    return container.clientWidth;
  }

  getHeight(container) {
    return container.clientHeight;
  }

  updateDimensions = () => {
    const containerWidth = this.getWidth(this.container);

    if (containerWidth !== this.state.containerWidth) {
      let maxContainerWidth = Math.max(this.state.maxContainerWidth || 0, containerWidth);
      this.setState({...this.state, maxContainerWidth, containerWidth});
  }
}

handleResize = () => {
  if (this.rqf) return;
  this.rqf = this.getWindow().requestAnimationFrame(() => {
    this.rqf = null;
    this.updateDimensions();
  });
}

handleError = (e) => {
  this.setState({...this.state, error: true});
if (this.props.handleError) {
  this.props.handleError(e);
}
  }

getWindow() {
  return (this.container && this.container.ownerDocument) ? (this.container.ownerDocument.defaultView || window) : window;
}

componentDidMount() {
  if (this.container) {
    this.updateDimensions();
    if (this.state.isResponsive) {
      this.getWindow().addEventListener(RESIZE_EVENT, this.handleResize);
    }
  }
}

componentWillUnmount() {
  if (this.state.isResponsive) {
    this.getWindow().removeEventListener(RESIZE_EVENT, this.handleResize);
  }
}

closestAbove(a, i){
  let val;
  for (let j of a) {
    if (j > i) {
      val = j;
      break;
    }
  }
  return val;
}

render() {
  let transformation = new cloudinary.Transformation();
  let descriptor = CloudinaryUtil.swapDPR(this.props.transformation);
  descriptor = CloudinaryUtil.swapWidth(descriptor, this.breakpoints(this.state.maxContainerWidth));
  transformation.fromOptions(descriptor);
  let format = this.props.format;
  let src = this.cl.url(this.props.publicId, {
    transformation,
    format,
    private_cdn: this.props.privateCdn,
    cname: this.props.cname,
    secure_distribution: this.props.secureDistribution
  });
  if (this.state.isResponsive && !this.state.maxContainerWidth) {
    src = this.props.responsivePlaceholder || '';
  }
  let html = transformation.toHtmlAttributes();
  let containerStyle = this.props.containerStyle || CloudinaryImage.containerStyle;
  let {imageClassName, imageStyle} = this.props;
  if (this.state.error) {
    imageStyle = { display: 'none' };
  }

  return (
    <div style={containerStyle} className={this.props.containerClassName}
      ref={(node) => { this.container = node; }}>
      <img src={src}
        width={this.props.width || html.width}
        height={this.props.height || html.height}
        id={this.props.id}
        onLoad={this.props.handleLoad}
        onError={this.handleError}
        style={imageStyle}
        className={imageClassName} />
    </div>
  );
}
}

let compareObjects = (o, p) => {
  let i,
    keysO = Object.keys(o).sort(),
    keysP = Object.keys(p).sort();
  if (keysO.length !== keysP.length) return false;
  if (keysO.join('') !== keysP.join('')) return false;
  for (i = 0; i < keysO.length; ++i) {
    if (o[keysO[i]] instanceof Array) {
      if (!(p[keysO[i]] instanceof Array)) return false;
      if (p[keysO[i]].sort().join('') !== o[keysO[i]].sort().join('')) return false;
    }
    else if (o[keysO[i]] instanceof Function) {
      if (!(p[keysO[i]] instanceof Function)) return false;
    }
    else if (o[keysO[i]] instanceof Object) {
      if (!(p[keysO[i]] instanceof Object)) return false;
      if (o[keysO[i]] === o) {
        if (p[keysO[i]] !== p) return false;
      } else if (compareObjects(o[keysO[i]], p[keysO[i]]) === false) {
        return false;//WARNING: does not deal with circular refs other than ^^
      }
    }
    if (o[keysO[i]] != p[keysO[i]]) return false;//not the same value
  }
  return true;
};



/** WEBPACK FOOTER **
 ** ./src/js/components/CloudinaryImage.js
 **/